document.addEventListener("DOMContentLoaded", () => {
  let MysterySwiper = null;

  function throttle(func, delay = 100) {
    let timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(() => {
          func.apply(this, arguments);
          timer = null;
        }, delay);
      }
    };
  }

  function handleSwiper() {
    const windowWidth = $(window).width();

    if (windowWidth < 769) {
      if (!MysterySwiper) {
        MysterySwiper = new Swiper(".mystery-pro-list", {
          pagination: {
            el: ".swiper-pagination",
          },
        });
      }
    } else {
      if (MysterySwiper) {
        MysterySwiper.destroy(true, true);
        MysterySwiper = null;
      }
    }
  }

  handleSwiper();

  $(window).on("resize", throttle(handleSwiper));
});
